import UtilityService from './utility-service';

const API_URL =
  process.env.NODE_ENV === 'development'
    ? process.env.NEXT_PUBLIC_API_URL_DEVELOPMENT
    : UtilityService.getApiUrl();

const AURORA_API_URL =
  process.env.NODE_ENV === 'development'
    ? process.env.NEXT_PUBLIC_AURORA_API_URL_DEVELOPMENT
    : UtilityService.getAuroraApiUrl();

const Request = {
  async post(endpoint: string, body: any, aurora: boolean = false): Promise<Response | undefined> {
    try {
      let config: RequestInit;

      if (body instanceof FormData) {
        config = {
          method: 'POST',
          credentials: 'include',
          body,
        };
      } else {
        config = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          } as HeadersInit,
          credentials: 'include',
          body: JSON.stringify(body),
        };
      }

      const response = await fetch(`${!aurora ? API_URL : AURORA_API_URL}${endpoint}`, config);

      if (!response.ok) {
        // Allow callers to handle 429 (limit reached) for Aurora endpoints
        if (aurora && response.status === 429) {
          return response;
        }
        throw new Error(`Error on POST request. Status: ${response.status}`);
      }

      return response;
    } catch (error) {
      console.log(error);
      return undefined;
    }
  },

  async get(endpoint: string, aurora: boolean = false): Promise<Response | undefined> {
    try {
      const config: RequestInit = {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        } as HeadersInit,
        credentials: 'include',
      };

      const response = await fetch(`${!aurora ? API_URL : AURORA_API_URL}${endpoint}`, config);

      if (!response.ok) {
        // Allow callers to handle 429 (limit reached) for Aurora endpoints
        if (aurora && response.status === 429) {
          return response;
        }
        throw new Error(`Error on GET request. Status: ${response.status}`);
      }

      return response;
    } catch (error) {
      console.log(error);
      return undefined;
    }
  },

  async put(endpoint: string, body: any, aurora: boolean = false): Promise<Response | undefined> {
    try {
      let config: RequestInit;

      if (body instanceof FormData) {
        config = {
          method: 'PUT',
          credentials: 'include',
          body,
        };
      } else {
        config = {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
          } as HeadersInit,
          credentials: 'include',
          body: JSON.stringify(body),
        };
      }

      const response = await fetch(`${!aurora ? API_URL : AURORA_API_URL}${endpoint}`, config);

      if (!response.ok) {
        throw new Error(`Error on PUT request. Status: ${response.status}`);
      }

      return response;
    } catch (error) {
      console.log(error);
      return undefined;
    }
  },

  async delete(
    endpoint: string,
    body: any,
    aurora: boolean = false,
  ): Promise<Response | undefined> {
    try {
      const config: RequestInit = {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        } as HeadersInit,
        credentials: 'include',
        body: JSON.stringify(body),
      };

      const response = await fetch(`${!aurora ? API_URL : AURORA_API_URL}${endpoint}`, config);

      if (!response.ok) {
        throw new Error(`Error on DELETE request. Status: ${response.status}`);
      }

      return response;
    } catch (error) {
      console.log(error);
      return undefined;
    }
  },
};

export default Request;
